import { render, staticRenderFns } from "./ListAreas.vue?vue&type=template&id=d4951c3e&scoped=true&"
import script from "./ListAreas.vue?vue&type=script&lang=js&"
export * from "./ListAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4951c3e",
  null
  
)

export default component.exports